<template>
  <div>
    <template v-if="stores.length === 0">
      <h2 class="c-pageTitle">店舗が未作成です</h2>
      <p>店舗を新規作成して、Google マップ連携か口コミサイト連携をしてください</p>
      <div v-if="isMoreThanEditor" class="c-button c-button--left">
        <router-link :to="{ name: 'CompaniesLocationStoreNew', params: { company_uuid: companyUuid } }" class="c-button__item c-button__item--primary">
          <img :src="iconPlusPath" alt="" class="c-button__icon">
          店舗を新規登録する
        </router-link>
      </div>
    </template>
    <template v-else>
      <h2 class="c-pageTitle">口コミサイトと連携されていません</h2>
      <p v-if="isMoreThanEditor">
        <router-link :to="{ name: 'CompaniesLocationStores', params: { company_uuid: companyUuid, store_uuid: stores[0].uuid } }">
          店舗詳細の連携ページ
        </router-link>
        から、Google ビジネスプロフィール連携もしくは口コミサイト連携をしてください
      </p>
      <p v-else>
        {{ $t('components.GuideToSetUpSite.lessThanOperator.info1') }}
      </p>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import iconPlusPath from '../../../images/common/icon_plus.svg'

export default {
  name: 'GuideToSetUpSite',
  props: {
    isMoreThanEditor: {
      type: Boolean,
      required: false
    }
  },
  data: function() {
    return {
      companyUuid: this.$route.params.company_uuid,
      iconPlusPath
    }
  },
  computed: {
    ...mapState({
      stores: state => state.companiesStores.data?.data
    }),
  }
}
</script>
